import { TYPES } from './actions';
import entity from './entity';

import { merge } from '../../../../utils/state';
import { omit } from '../../../../utils/utils';
import ReduxRestEntity from '../../../../utils/reduxRestEntity';

const coreReducer = entity.getReducer();

const INITIAL_STATE = {
  ...ReduxRestEntity.initialState,
  isUpdating: false,
  jobTitleSearch: {
    ...ReduxRestEntity.initialState,
  },
  pagination: {
    pageSize: 15,
    pageNumber: 1,
    hasMore: false,
    totalElements: 0,
  },
};


const reducer = (state = INITIAL_STATE, action = {}) => {
  switch (action.type) {
    case TYPES.GET_JOBS_REQUEST:
      if (action.payload?.page === 1) {
        return {
          ...INITIAL_STATE,
          isLoading: true,
        };
      }
      return merge(state, {
        isLoading: true,
      });
    case TYPES.GET_JOBS_SUCCESS:
      return merge(state, {
        isLoading: false,
        data: merge(state.data, action.payload.content),
        pagination: merge(state.pagination, {
          pageNumber: action.payload.pagination.page_current,
          hasMore: action.payload.pagination.page_total > action.payload.pagination.page_current,
          totalElements: action.payload.pagination.element_total,
          totalPages: action.payload.pagination.page_total,
        }),
      });
    case TYPES.GET_JOBS_FAILURE:
      return merge(state, {
        isLoading: false,
        error: action.payload,
        pagination: merge(state.pagination, {
          totalElements: 0,
        }),
      });
    case TYPES.CREATE_JOB_REQUEST:
      return merge(state, {
        isLoading: true,
        newJobId: null,
        error: null,
      });
    case TYPES.CREATE_JOB_SUCCESS:
      return merge(state, {
        isLoading: false,
        newJobId: action.payload.id,
        error: null,
        data: { ...omit(['id'], action.payload), ...state.data },
      });
    case TYPES.CREATE_JOB_FAILURE:
      return merge(state, {
        isLoading: false,
        newJobId: null,
        error: action.payload,
      });
    case TYPES.UPDATE_REQUEST:
      return merge(state, {
        isUpdating: true,
      });
    case TYPES.UPDATE_REQUEST_SUCCESS:
      return merge(state, {
        isUpdating: false,
        data: merge(state.data, action.payload),
      });
    case TYPES.UPDATE_REQUEST_ERROR:
      return merge(state, {
        isUpdating: false,
        error: action.payload,
      });
    case TYPES.INCREMENT_TOTAL_JOBS:
      return merge(state, {
        pagination: {
          ...state.pagination,
          totalElements: state.pagination.totalElements + 1,
        },
      });
    case TYPES.JOB_TITLE_SEARCH_REQUEST:
      return merge(state, {
        jobTitleSearch: merge(state.jobTitleSearch, {
          error: null,
          isLoading: true,
        }),
      });
    case TYPES.JOB_TITLE_SEARCH_SUCCESS:
      return merge(state, {
        jobTitleSearch: merge(state.jobTitleSearch, {
          data: merge(state.jobTitleSearch.data, action.payload),
          error: null,
          isLoading: false,
        }),
      });
    case TYPES.JOB_TITLE_SEARCH_FAILURE:
      return merge(state, {
        jobTitleSearch: merge(state.jobTitleSearch, {
          error: action.payload,
          isLoading: false,
        }),
      });
    case TYPES.CLEAR_NEW_JOB_ID:
      return merge(state, {
        newJobId: null,
      });
    case TYPES.CLEAR_STATE:
      return INITIAL_STATE;
    default:
      return coreReducer(state, action);
  }
};

export default reducer;
